
import { PasswordInputWithValidatorProps, ValidationItem } from './PasswordValidator.interfaces';
import { REG_EXP_MINIMUM_EIGHT_CHARACTERS, REG_EXP_NUMBER, REG_EXP_ONE_LOWERCASE, REG_EXP_ONE_UPPERCASE } from './PasswordValidator.constants';

export const PasswordValidator = ({ firstPassword, secondPassword }: PasswordInputWithValidatorProps) => {

  const validationItems: ValidationItem[] = [
    {
      label: 'Passwords match',
      inValidText: 'Both password do not match',
      successText: 'Both passwords match',
      isValid: Boolean(firstPassword) && Boolean(secondPassword) && firstPassword === secondPassword,
    },
    {
      label: 'Minimum 8 characters',
      inValidText: 'Password does not have the minimum character amount',
      successText: 'Password has minimum character amount',
      isValid: RegExp(REG_EXP_MINIMUM_EIGHT_CHARACTERS.source, 'g').exec(firstPassword) !== null,
    },
    {
      label: 'Number (0-9)',
      inValidText: 'Password does not contains a number',
      successText: 'Password contains a number',
      isValid: RegExp(REG_EXP_NUMBER.source, 'g').exec(firstPassword) !== null,
    },
    {
      label: 'An uppercase letter',
      inValidText: 'Password does not contain an uppercase character',
      successText: 'Password contains a uppercase character',
      isValid: RegExp(REG_EXP_ONE_UPPERCASE.source, 'g').exec(firstPassword) !== null,
    },
    {
      label: 'An lowercase letter',
      inValidText: 'Password does not contain a lowercase character',
      successText: 'Password contains a lowercase character',
      isValid: RegExp(REG_EXP_ONE_LOWERCASE.source, 'g').exec(firstPassword) !== null,
    },
  ];

  return (
    <ul className="flex flex-col ml-0">
      {validationItems.map(({ inValidText, isValid, label, successText }) => (
        <li
          key={label}
          className={`flex items-center ml-0 mb-4 ${isValid ? 'color-green-400' : ''}`}
        >
          <span className="sr-only">{isValid ? successText : inValidText}</span>
          <svg
            aria-hidden="true"
            className="w-4 h-4 mr-2 transition-200"
            color={isValid ? 'var(--green-400)' : '#c7ccd8'}
            height="41"
            id="tick-icon"
            viewBox="0 0 41 41"
            width="41"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle cx="20.5" cy="20.5" data-name="Ellipse 891" fill="currentColor" id="Ellipse_891" r="20.5" />
            <path
              d="M2633.267,588.9l7.442,7.037,10.224-15.154"
              data-name="Path 43408"
              fill="none"
              id="Path_43408"
              stroke="#fff"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="5"
              transform="translate(-2621.6 -567.859)"
            />
          </svg>
          <span className="text-sm mb-0">{label}</span>
        </li>
      ))}
    </ul>
  );
};